import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "menuTree--box" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "menuTree--box--title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "menuTree--box--titleContent" }, "一级"),
  /*#__PURE__*/_createElementVNode("div", { class: "menuTree--box--titleContent" }, "二级")
], -1)
const _hoisted_3 = { class: "menuTree--boxContentText" }
const _hoisted_4 = { class: "menuTree--boxContentText__item" }
const _hoisted_5 = { class: "menuTree--boxContentText--subset" }
const _hoisted_6 = { class: "addRoleView__data" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, "允许管理哪些部门的单据、员工?", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_tree_select = _resolveComponent("a-tree-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    ref: "editorForm",
    class: "addRoleView__form",
    model: _ctx.formData,
    "label-col": _ctx.labelCol,
    "wrapper-col": _ctx.wrapperCol,
    rules: _ctx.rules,
    onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_form_item, {
        label: "角色名称",
        name: "roleName",
        required: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_input, {
            value: _ctx.formData.roleName,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.roleName) = $event)),
            "allow-clear": ""
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "角色说明",
        name: "instruction",
        required: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_textarea, {
            value: _ctx.formData.instruction,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.instruction) = $event)),
            class: "text-count-50",
            "data-count-max": 50,
            rows: 5,
            "show-count": "",
            maxlength: 50
          }, null, 8, ["value"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, {
        label: "菜单权限",
        name: "menus",
        required: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuTree, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "menuTree--boxContent"
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_a_checkbox, {
                      checked: item.state === 'OPEN',
                      onChange: ($event: any) => (_ctx.onCheckAllChange(item))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.menuName), 1)
                      ]),
                      _: 2
                    }, 1032, ["checked", "onChange"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (_item, _index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: _index,
                      class: "menuTree--boxContentText--subset__item"
                    }, [
                      _createVNode(_component_a_checkbox, {
                        checked: _item.state === 'OPEN',
                        onChange: ($event: any) => (_item.state = (_item.state === 'OPEN' ? 'CLOSE' : 'OPEN'), _ctx.onChangeChild(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_item.menuName), 1)
                        ]),
                        _: 2
                      }, 1032, ["checked", "onChange"])
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      }),
      false
        ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 0,
            label: "数据权限",
            required: "",
            style: {"margin-bottom":"0"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_a_radio_group, {
                  value: _ctx.formData.departmentState,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.departmentState) = $event)),
                  options: _ctx.departmentOptions
                }, null, 8, ["value", "options"])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_form_item, {
        "wrapper-col": { span: 14, offset: 5 },
        name: "departmentRels"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_a_tree_select, {
              value: _ctx.formData.departmentRels,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.departmentRels) = $event)),
              style: {"width":"100%"},
              "allow-clear": "",
              "search-placeholder": "请选择",
              multiple: "",
              "show-line": true,
              "tree-data": _ctx.departmentTree
            }, null, 8, ["value", "tree-data"])
          ], 512), [
            [_vShow, _ctx.formData.departmentState === 'OTHER']
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_form_item, { "wrapper-col": { span: 14, offset: 5 } }, {
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            style: {"margin-right":"10px"},
            onClick: _ctx.onCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            type: "primary",
            disabled: _ctx.submiting,
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode("提交")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "label-col", "wrapper-col", "rules", "onSubmit"]))
}